import m from "./../../../dist/es2015/locales/en_US.js";
export const am5locales_en_US = m;